var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinEos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46Z",
    fill: "url(#paint0_linear_1636_7997)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.463 17.8595L23 8.9562L16.537 17.8595L13.8 31.0776L23 36.6712L32.2115 31.0776L29.463 17.8595ZM28.658 20.7966L30.6567 30.4014L24.1132 34.3735L28.658 20.7966ZM28.0439 18.2666L23 33.3316L17.9561 18.2643L23 11.316L28.0439 18.2666ZM17.342 20.7966L21.8868 34.3666L15.3456 30.4014L17.342 20.7966Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1636_7997",
    x1: 23,
    y1: 46,
    x2: 23,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1045BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5287FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinEos);
export default __webpack_public_path__ + "static/media/coin_eos.62f51bf103d239de6854ba0bbdd39ae1.svg";
export { ForwardRef as ReactComponent };